import React, { createContext, useReducer } from 'react';

interface AddressState {
  addressObj: any;
  changeContentData: any;
  changeEntityData: any;
  addressId: any;
}
interface AddressContextProps {
  state: AddressState;
  dispatch: React.Dispatch<any>;
}

// type AddressAction = { type: 'UPLOAD_ADDRESS'; payload: any };

const initialState: AddressState = {
  addressObj: {},
  changeContentData: {},
  changeEntityData: {},
  addressId: ''
};

const addressReducer = (state: any, action: { type: string; payload: any }) => {
  switch (action.type) {
    case 'UPLOAD_ADDRESS':
      return {
        ...state,
        addressObj: action.payload
      };
    case 'ADDRESS_ID':
      return {
        ...state,
        addressId: action.payload
      };
    case 'UPLOAD_CHANGE_CONTENT':
      return {
        ...state,
        changeContentData: action.payload
      };
    case 'UPLOAD_CHANGE_ENTITY':
      return {
        ...state,
        changeEntityData: action.payload
      };
    default:
      return state;
  }
};

const useAddressReducer = (): [AddressState, React.Dispatch<any>] => {
  const [state, dispatch] = useReducer(addressReducer, initialState);
  return [state, dispatch];
};

const AddressContext = createContext<AddressContextProps>({
  state: initialState,
  dispatch: () => {}
});

const AddressProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useAddressReducer();

  return <AddressContext.Provider value={{ state, dispatch }}>{children}</AddressContext.Provider>;
};

export { AddressContext, AddressProvider };
